export const environment = {
  firebase: {
    apiKey: "AIzaSyDU1qVjUSOJygbDXWDM84BHvIo5OGjFaIg",
    authDomain: "staging.aredivisionsout.com",
    databaseUrl: "https://divisions-staging-default-rtdb.firebaseio.com",
    projectId: "divisions-staging",
    storageBucket: "divisions-staging.firebasestorage.app",
    messagingSenderId: "80898424376",
    appId: "1:80898424376:web:672fc26fcfdbd07efdb0cd",
    measurementId: "G-DB0BN7D26D"
  },
  production: true,
  useEmulatedFunctions: false,
  hostUrl: 'https://staging.aredivisionsout.com',
  vapidKey: 'BGNuAiNz5Yo4_ELgPyhjpKKI0wddkRIK8tjA23r6VR876KPJ3by46LuV1IduyE19XcD_wIK2thZ1JwnzZN_x6NY',
  stripeKey: 'pk_test_51RldIWPxruSeRgwd8Cg4cadqO5CzekHM2KM9omeJdUudA3PwEsyDdtp9ea6D6gkgoTAL2RFjbuAhF2WS5jUex7HM003nIIwo13',
};
